export default {"src":"/_next/static/media/user-account.09013b48.svg","height":24,"width":20};